









import {Vue, Component, Prop} from "vue-property-decorator";

@Component
export default class CardIcon extends Vue {
    @Prop({default: "24px"})
    height!: string;

    @Prop({default: "24px"})
    width!: string;

    @Prop({default: "#0000008a"})
    color!: string;
}
